"use strict";
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSearchParams = exports.getFedmodUrl = exports.resetOverrides = exports.removeOverride = exports.getOverrides = void 0;
const getOverrides = (clientNames) => {
    const list = new Map();
    if (typeof window === "undefined") {
        return list;
    }
    for (const name of clientNames) {
        // stay backwards compatible
        if (localStorage.getItem(name + "_client")) {
            list.set(name, localStorage.getItem(name + "_client"));
        }
        if (localStorage.getItem(name)) {
            list.set(name, localStorage.getItem(name));
        }
    }
    return list;
};
exports.getOverrides = getOverrides;
const removeOverride = (name) => {
    localStorage.removeItem(name);
    // stay backwards compatible
    localStorage.removeItem(name + "_client");
};
exports.removeOverride = removeOverride;
const resetOverrides = (clientNames) => {
    for (const name of clientNames) {
        (0, exports.removeOverride)(name);
    }
};
exports.resetOverrides = resetOverrides;
// special cases where the fedmod name doesn't match the name in the url
// fedmod name is defined in the webpack config and referenced in code
// the name in the url is coming from doggy package name
const mapFedmodName = (name) => {
    switch (name) {
        case "join": {
            return "federatedjoin";
        }
        case "payouts": {
            return "payoutpreferences";
        }
        default: {
            return name;
        }
    }
};
const getFedmodUrl = (name, value) => {
    const entryPoint = name === "hybrid" ? "hybrid/hc.js" : "remoteEntry.js";
    if (value.startsWith("localhost")) {
        const [, port] = value.split(":");
        return name === "hybrid"
            ? `http://localhost:${port ?? 8069}/hc.js`
            : `http://localhost:${port ?? 3414}/remoteEntry.js`;
    }
    if (["integ", "staging"].includes(value)) {
        switch (name) {
            case "hybrid":
                return `https://hybridclient.${value}.naiadsystems.com/dist/hybrid/hc.js`;
            case "search":
            case "contentcomplaint":
            case "join":
            case "accountmanagement":
                return `https://streamate.${value}.icfcdn.com/${name}/remoteEntry.js`;
            default:
                return `https://federatedmodules.${value}.icfcdn.com/${name}/remoteEntry.js`;
        }
    }
    if (value === "production") {
        switch (name) {
            case "hybrid":
                return `https://cdn.hybridclient.naiadsystems.com/dist/hybrid/hc.js`;
            case "search":
            case "contentcomplaint":
            case "join":
            case "accountmanagement":
                return `https://streamate.icfcdn.com/${name}/remoteEntry.js`;
            default:
                return `https://federatedmodules.icfcdn.com/${name}/remoteEntry.js`;
        }
    }
    if (value === "origin") {
        switch (name) {
            case "hybrid":
                return `https://hybridclient.naiadsystems.com/dist/hybrid/hc.js`;
            case "search":
            case "contentcomplaint":
            case "join":
            case "accountmanagement":
                return `https://streamate-origin-fb.icfcdn.com/${name}/remoteEntry.js`;
            default:
                return `https://federatedmodules-origin-fb.icfcdn.com/${name}/remoteEntry.js`;
        }
    }
    const previewName = mapFedmodName(name);
    return `https://previewcdn.integ.icfcdn.com/${previewName}.client/${value}/dist/${entryPoint}`;
};
exports.getFedmodUrl = getFedmodUrl;
const parseSearchParams = (urlString, clientNames) => {
    const url = new URL(urlString);
    const list = new Map();
    url.searchParams.forEach((value, name) => {
        if (!clientNames.includes(name)) {
            return;
        }
        const clientUrl = (0, exports.getFedmodUrl)(name, value);
        list.set(name, clientUrl);
        localStorage.setItem(name, clientUrl);
        url.searchParams.delete(name);
    });
    if (list.size > 0) {
        history.replaceState(null, "", url.href);
    }
    return list;
};
exports.parseSearchParams = parseSearchParams;
